import React from "react";
import { Table } from "reactstrap";
import PropTypes from "prop-types";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";

import style from "../Grid.module.scss";

const EarningAccounts = ({ accounts }) => (
  <div className={style.grid}>
    <h6 className="my-3">Accounts</h6>
    <Table responsive hover>
      <thead>
        <tr>
          <th>Account</th>
          <th>Volume</th>
          <th>Balance</th>
        </tr>
      </thead>
      <tbody>
        {accounts.map((item) => (
          <tr key={item.EarningAccountId}>
            <td>{item.EarningAccountName}</td>
            <td className="text-right">
              <FormattedNumber value={item.EarningAccountVolume} dataTypeDecimalName="currency" />
            </td>
            <td className="text-right">
              <FormattedNumber value={item.EarningAccountBalance} dataTypeDecimalName="currency" />
            </td>
          </tr>
        ))}
        {accounts.length === 0 && (
          <tr>
            <td colSpan={8} style={{ textAlign: "center" }}>
              No Accounts
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
);

EarningAccounts.propTypes = {
  accounts: PropTypes.array.isRequired,
};

export default EarningAccounts;
